<template>
  <div class="save-retention-options">
    <h6 class="save-retention-options__title">{{ title }}</h6>
    <div class="save-retention-options__persist form-group">
      <CSwitch
        color="success"
        :checked="persistValue"
        @update:checked="updatePersistValue"
      />
      <div class="save-retention-options__persist-copy px-3">
        <div class="save-retention-options__persist-label">{{ persistLabel }}</div>
        <div class="save-retention-options__persist-hint">{{ persistHint }}</div>
      </div>
    </div>
    <div class="save-retention-options__list">
      <div
        v-for="option in options"
        :key="option.key"
        class="save-retention-options__item form-group"
      >
        <CSwitch
          color="success"
          :checked="Boolean(value[option.key])"
          @update:checked="updateOption(option.key, $event)"
        />
        <span class="label px-3">{{ option.label }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SaveRetentionOptions',
  props: {
    options: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      default: 'Nach dem Speichern behalten'
    },
    persistLabel: {
      type: String,
      default: 'Auswahl merken'
    },
    persistHint: {
      type: String,
      default: 'Ohne Merken werden die Behalten-Optionen wieder auf den Standard zurückgesetzt. Das ist hilfreich beim Nachtragen mehrerer Einträge hintereinander.'
    },
    persistValue: {
      type: Boolean,
      default: false
    },
    value: {
      type: Object,
      required: true
    }
  },
  methods: {
    updatePersistValue (checked) {
      this.$emit('update:persistValue', checked)
    },
    updateOption (key, checked) {
      this.$emit('input', {
        ...this.value,
        [key]: checked
      })
    }
  }
}
</script>

<style lang="scss">
.save-retention-options {
  border-top: 1px solid #d8dbe0;
  margin-top: 1.5rem;
  padding-top: 1rem;
}

.save-retention-options__title {
  font-size: 0.95rem;
  font-weight: 600;
  margin-bottom: 0.75rem;
}

.save-retention-options__persist {
  align-items: center;
  background: #f5f6f8;
  border: 1px solid #d8dbe0;
  border-radius: 18px;
  display: flex;
  margin-bottom: 1rem;
  padding: 0.85rem 1rem;
}

.save-retention-options__persist-copy {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
}

.save-retention-options__persist-label {
  color: #1f2933;
  font-weight: 600;
  line-height: 1.2;
}

.save-retention-options__persist-hint {
  color: #6c757d;
  font-size: 0.85rem;
  line-height: 1.35;
}

.save-retention-options__list {
  display: grid;
  gap: 0.35rem 1rem;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
}

.save-retention-options__item {
  align-items: center;
  display: flex;
  margin-bottom: 0;
}
</style>
